import {RSAnimation} from '../../be/redskythirty/effects/animation';

import Cookies from 'js-cookie';


export class CookieConsent
{
	static get COOKIE_NAME() { return 'cookie-consent'; } // Utilisé également en dur dans le fichier "CookieConsent.php"
	
	
	/**
	 * @param {HTMLElement} element
	 * @param {int} delay
	 */
	constructor(element, delay = 1000)
	{
		this.element = element;
		
		this._init(delay);
	}
	
	
	//
	// Public Methods
	//
	
	/**
	 * @public
	 */
	open()
	{
		RSAnimation.fadeIn(this.element, 350, null, 'flex');
	}
	
	
	/**
	 * @public
	 */
	close()
	{
		RSAnimation.fadeOut(this.element);
	}
	
	
	//
	// Private Methods
	//
	
	/**
	 * @param {int} delay
	 * @private
	 */
	_init(delay)
	{
		const _class = this;
		const elAccept = this.element.querySelector('.js-accept');
		const elDecline = this.element.querySelector('.js-decline');
		
		if (elAccept != null)
		{
			elAccept.addEventListener('click', (event) => {
				event.preventDefault();
				
				_class._setCookie({
					updated_at: new Date(),
					gg_analytics: 1,
					fb_pixel: 1
				});
				
				window.location.reload();
			});
		}
		
		if (elDecline != null)
		{
			elDecline.addEventListener('click', (event) => {
				event.preventDefault();
				
				_class._setCookie({
					updated_at: new Date(),
					gg_analytics: 0,
					fb_pixel: 0
				});
				
				_class.close();
			});
		}
		
		setTimeout(() => {
			_class.open();
		}, delay);
	}
	
	
	/**
	 * @param {?Object} data
	 * @private
	 */
	_setCookie(data)
	{
		if(data != null)
		{
			Cookies.set(CookieConsent.COOKIE_NAME, JSON.stringify(data), { expires: 365 });
			
			if((typeof data.gg_analytics !== 'undefined') && (data.gg_analytics === 0))
			{
				Cookies.remove('_ga');
				Cookies.remove('_gid');
			}
			
			if((typeof data.fb_pixel !== 'undefined') && (data.fb_pixel === 0))
			{
				Cookies.remove('_fbp');
			}
		}
		else
		{
			Cookies.remove(CookieConsent.COOKIE_NAME);
		}
	}
}
